// ╔══════════════════════════════════════════════════════════╗
//  businessConfig.js
//  ⭐ THIS IS THE ONLY FILE YOU CHANGE PER CLIENT ⭐
//  Everything on the website reads from here.
//  To reuse for another customer → just edit this file only.
// ╚══════════════════════════════════════════════════════════╝

const businessConfig = {

  // ── IDENTITY ──────────────────────────────────────────────
  name:        "1464 Country Cleaners",
  shortName:   "1464 Country Cleaners",
  tagline:     "Care Beyond the Clean",
  description: "Houston's most trusted professional dry cleaning & laundry service. From delicate dry cleaning to wash and fold — affordable pricing, expert care.",
  logo:        "/images/logo.png",
  logoIsImage: true,
  location:    "Houston, TX, USA",

  // ── SEO ───────────────────────────────────────────────────
  seo: {
    title:       "1464 Country Cleaners – Dry Cleaning & Laundry | Houston, TX",
    description: "Professional dry cleaning and laundry in Houston, TX. Affordable pricing per pound. Free pickup & delivery. Same-day service available. Trusted by 2,000+ customers.",
    keywords:    "dry cleaning Houston, laundry Houston, wash and fold Texas, laundry pickup delivery, same day dry cleaning, 1464 country cleaners",
    author:      "1464 Country Cleaners",
    url:         "https://1464countrycleaners.com",
    themeColor:  "#2B3990",
  },

  // ── CONTACT ───────────────────────────────────────────────
  phone:        "(281) 277-0001",
  phoneDial:    "2812770001",
  whatsapp:     "12812770001",
  email:        "1464countrycleaners@gmail.com",
  address:      "17251 Westheimer Rd, Houston, TX 77082",
  addressShort: "17251 Westheimer Rd, Houston TX",
  mapsUrl:      "https://maps.google.com/?q=17251+Westheimer+Rd+Houston+TX+77082",

  // ── HOURS ─────────────────────────────────────────────────
  hours: [
    { day: "Mon – Fri", time: "7:30 AM – 6:30 PM" },
    { day: "Saturday",  time: "9:00 AM – 3:00 PM"  },
    { day: "Sunday",    time: "Closed"              },
  ],

  // ── BRAND COLORS ──────────────────────────────────────────
  colors: {
    primary:  "#2B3990",
    accent:   "#7AB648",
    light:    "#6BB8E8",
    dark:     "#1A2460",
    surface:  "#F4F8FF",
  },

  // ── FONT PREFERENCE ───────────────────────────────────────
  font: "Poppins",

  // ── SOCIAL MEDIA ──────────────────────────────────────────
  social: {
    facebook:  "https://www.facebook.com/share/18ULoxo8ZP/",
    instagram: "https://www.instagram.com/1464_country_cleaners",
    tiktok:    "https://www.tiktok.com/@1464countrycleaners",
    twitter:   null,
    youtube:   null,
  },

  // ── STATS ─────────────────────────────────────────────────
  stats: [
    { number: "2,000+", label: "Happy Customers"  },
    { number: "98%",    label: "Satisfaction Rate" },
    { number: "24hr",   label: "Turnaround"        },
    { number: "4.9★",  label: "Google Rating"     },
  ],

  // ── TRUST BADGES ──────────────────────────────────────────
  trustBadges: [
    { icon: "🛡️", text: "100% Safe & Insured"       },
    { icon: "🚚", text: "Free Pickup & Delivery"     },
    { icon: "⚡", text: "Same-Day Service Available" },
    { icon: "🌿", text: "Eco-Friendly Products"      },
    { icon: "📱", text: "Real-Time Order Tracking"   },
  ],

  // ── HOW IT WORKS STEPS ────────────────────────────────────
  steps: [
    {
      number: "01",
      icon:   "📱",
      title:  "Book Online",
      desc:   "Schedule your pickup in seconds via our website or give us a call.",
    },
    {
      number: "02",
      icon:   "🚚",
      title:  "Free Pickup",
      desc:   "Our driver arrives at your door at your chosen date and time.",
    },
    {
      number: "03",
      icon:   "👕",
      title:  "Expert Cleaning",
      desc:   "Your garments receive professional treatment at our facility.",
    },
    {
      number: "04",
      icon:   "✅",
      title:  "Delivery",
      desc:   "Fresh, clean clothes delivered right back to your door.",
    },
  ],

  // ── SERVICES ──────────────────────────────────────────────
  services: [
    {
      id:       "dry-cleaning",
      icon:     "🧥",
      name:     "Dry Cleaning",
      desc:     "Gentle solvent cleaning for delicate and formal garments. Expert care for suits, dresses, and specialty fabrics.",
      unit:     "per item",
      duration: "48 hours",
      active:   true,
      popular:  true,          // ← MOST POPULAR
    },
    {
      id:       "wash-fold",
      icon:     "👕",
      name:     "Wash & Fold",
      desc:     "Machine washed, dried, and neatly folded. Affordable pricing per pound — perfect for everyday laundry.",
      unit:     "per lb",
      duration: "24 hours",
      active:   true,
      popular:  false,
    },
    {
      id:       "alterations",
      icon:     "🧵",
      name:     "Alterations",
      desc:     "Expert tailoring and alterations — hems, repairs, resizing and more. We make your clothes fit perfectly.",
      unit:     "per item",
      duration: "48 hours",
      active:   true,
      popular:  false,
    },
    {
      id:       "press-only",           // ← renamed from iron-only
      icon:     "👔",
      name:     "Press Only",           // ← Iron Only → Press Only
      desc:     "Crisp, wrinkle-free results for already-clean clothes. A perfect professional press every time.",
      unit:     "per item",
      duration: "12 hours",
      active:   true,
      popular:  false,
    },
    {
      id:       "duvet-wash",
      icon:     "🛏️",
      name:     "Duvet Wash",
      desc:     "Deep cleaning for duvets, comforters, and heavy bedding. Freshness you can feel.",
      unit:     "per piece",
      duration: "24 hours",
      active:   true,
      popular:  false,
    },
    // ── Stain Removal removed per client request ──
    {
      id:       "stain-removal",
      icon:     "🧹",
      name:     "Stain Removal",
      desc:     "Expert treatment for tough stains with guaranteed results.",
      unit:     "per item",
      duration: "24 hours",
      active:   false,         // ← HIDDEN from website
      popular:  false,
    },
  ],

  // ── SAME-DAY SERVICE POLICY ───────────────────────────────
  sameDayPolicy: {
    dropOffBy: "8:30 AM",
    readyBy:   "5:30 PM",
    note:      "Early morning? Drop-off station available at our store.",
  },

  // ── ORDER POLICY ─────────────────────────────────────────
  orderPolicy: {
    minimumGarments:    25,
    serviceRadiusMiles: "5–10",
    serviceAreaNote:    "Call us at (281) 277-0001 to confirm we service your area before booking.",
  },

  // ── PRICING CARDS ─────────────────────────────────────────
  // ⚠️ "Itemised Billing" removed. "Stain Removal" removed.
  pricingCards: [
    {
      icon:  "💰",
      title: "No Hidden Fees",
      desc:  "The price we quote is the price you pay. Always.",
    },
    {
      icon:  "📦",
      title: "25 Piece Minimum",
      desc:  "A minimum of 25 garments is required for free pickup & delivery to your door.",
    },
    {
      icon:  "📍",
      title: "Service Area: 5–10 Miles",
      desc:  "We serve customers within 5–10 miles. Call us to confirm we cover your area.",
    },
    {
      icon:  "✅",
      title: "Satisfaction Promise",
      desc:  "Not happy? We redo it free of charge. No questions asked.",
    },
  ],

  // ── PRICING PLANS ─────────────────────────────────────────
  plans: [
    {
      name:    "Basic",
      price:   "$15",
      period:  "visit",
      desc:    "Wash & Fold + Free Pickup — great for individuals",
      popular: false,
      features: [
        "Up to 5 lbs laundry",
        "Wash & Fold service",
        "Free pickup & delivery",
        "24hr turnaround",
      ],
    },
    {
      name:    "Premium",
      price:   "$30",
      period:  "visit",
      desc:    "Dry Cleaning + Laundry combo — our most popular",
      popular: true,
      features: [
        "Up to 10 lbs laundry",
        "2 dry-clean items included",
        "Priority scheduling",
        "Same-day option",
        "Free pickup & delivery",
      ],
    },
    {
      name:    "Business",
      price:   "$55",
      period:  "visit",
      desc:    "High-volume care for offices & families",
      popular: false,
      features: [
        "Unlimited laundry",
        "Dedicated driver",
        "Corporate invoice",
        "24/7 support",
        "Brand linen & uniform care",
      ],
    },
  ],

  // ── TESTIMONIALS ──────────────────────────────────────────
  testimonials: [
    {
      name:     "Mrs. Sarah Thompson",
      location: "Houston, TX",
      stars:    5,
      text:     "1464 Country Cleaners has completely changed how I handle laundry. My clothes come back perfectly clean, neatly folded, and always on time. I've been a loyal customer for over a year and have never been let down.",
    },
    {
      name:     "Mr. Michael Carter",
      location: "Sugar Land, TX",
      stars:    5,
      text:     "The dry cleaning quality here is exceptional. I trust 1464 with my most expensive suits before every business trip. Their attention to detail and fabric care is truly outstanding.",
    },
    {
      name:     "Dr. James R.",
      location: "Katy, TX",
      stars:    5,
      text:     "As a busy professional, I have no time to deal with laundry. The free pickup and delivery alone saves me several hours a week. Booking is simple, and the service is always professional.",
    },
    {
      name:     "Olivia Brown",
      location: "Missouri City, TX",
      stars:    5,
      text:     "I started using their wash and fold service for everyday clothes and now I bring my dress shirts for pressing too. Fast turnaround, fair pricing per pound, and my clothes always smell fresh.",
    },
    {
      name:     "Emily Parker",
      location: "Cypress, TX",
      stars:    5,
      text:     "I was skeptical at first but after my first order I was hooked. The dry cleaning service is incredible — they restored a suit I thought was ruined. Absolutely brilliant work.",
    },
    {
      name:     "Mr. Rodriguez",
      location: "The Woodlands, TX",
      stars:    5,
      text:     "Country Cleaners is the only laundry service I recommend to family and colleagues in the Houston area. Reliable, affordable, and genuinely professional. Perfect for our office uniforms.",
    },
  ],

  // ── FOOTER LINKS ──────────────────────────────────────────
  footerLinks: {
    // ⚠️ "Iron Only" → "Press Only", "Stain Removal" removed
    Services: ["Dry Cleaning", "Wash & Fold", "Alterations", "Press Only", "Duvet Wash"],
    Company:  ["About Us", "Our Team", "Blog", "Careers", "FAQs"],
    Legal:    ["Privacy Policy", "Terms of Service", "Refund Policy", "Cookie Policy"],
  },

};

export default businessConfig;